export const trayChargeQueryFields = `
    id
    enabled
    name
    fixedAmount
    posId
`;
